import {
    SET_BOOKINGLINES,
    FAILED_GET_BOOKINGLINES,
    SUCCESS_CREATE_BOOKING_LINE,
    SUCCESS_UPDATE_BOOKING_LINE,
    FAILED_CREATE_BOOKING_LINE,
    FAILED_UPDATE_BOOKING_LINE,
    SUCCESS_DELETE_BOOKING_LINE,
    FAILED_DELETE_BOOKING_LINE,
    SUCCESS_DELETE_BOOKING_LINES,
    FAILED_DELETE_BOOKING_LINES,
    SUCCESS_CALC_COLLECTED_LINE,
    FAILED_CALC_COLLECTED_LINE,
    RESET_FLAG_LINES,
    SUCCESS_GET_BOOKING_LINES_CNT,
    FAILED_GET_BOOKING_LINES_CNT,
    SUCCESS_GET_LINES_BULK,         // Bulk
    FAILED_GET_LINES_BULK,          // Bulk
    SUCCESS_EDIT_LINES_BULK,        // Bulk
    FAILED_EDIT_LINES_BULK,         // Bulk
} from '../constants/bookingLineConstants';

const defaultState = {
    bookingLines: [],
    errorMessage: null,
    needUpdateBookingLines: true,
    selectedBookingLinesCnt: null,
};

export const BookingLineReducer = (state = defaultState, { type, errorMessage, bookingLines, payload }) => {
    switch (type) {
        case RESET_FLAG_LINES:
            return {
                ...state,
                bookingLines: [],
                needUpdateBookingLines: false,
            };
        case SUCCESS_GET_BOOKING_LINES_CNT:
            return {
                ...state,
                selectedBookingLinesCnt: payload.count,
            };
        case SET_BOOKINGLINES:
            return {
                ...state,
                bookingLines: bookingLines,
                needUpdateBookingLines: false,
            };
        case SUCCESS_GET_LINES_BULK:
            return {
                ...state,
                bookingLines: payload,
            };
        case SUCCESS_EDIT_LINES_BULK:
            return {
                ...state,
                bookingLines: JSON.parse(JSON.stringify(payload)),
            };
        case SUCCESS_CREATE_BOOKING_LINE:
            return {
                ...state,
                needUpdateBookingLines: true,
                bookingLines: [...state.bookingLines, payload],
            };
        case SUCCESS_UPDATE_BOOKING_LINE: {
            const index = state.bookingLines.findIndex(line => line.pk_lines_id === payload.pk_lines_id);
            const _bookingLines = [...state.bookingLines];
            _bookingLines[index] = payload;

            return {
                ...state,
                needUpdateBookingLines: true,
                bookingLines: _bookingLines,
            };
        }
        case SUCCESS_DELETE_BOOKING_LINE: {
            const index = state.bookingLines.findIndex(line => line.pk_lines_id === payload.pk_lines_id);
            const _bookingLines = [...state.bookingLines];
            _bookingLines.splice(index, 1);

            return {
                ...state,
                needUpdateBookingLines: true,
                bookingLines: _bookingLines,
            };
        }
        case SUCCESS_DELETE_BOOKING_LINES: {
            let _bookingLines = [];
            state.bookingLines.map((line) => {
                const index = payload.findIndex(lineId => line.pk_lines_id === lineId);
                if (index === -1) _bookingLines.push(line);
            });

            return {
                ...state,
                needUpdateBookingLines: true,
                bookingLines: _bookingLines,
            };
        }
        case SUCCESS_CALC_COLLECTED_LINE:
            return {
                ...state,
                needUpdateBookingLines: true,
            };
        case FAILED_CALC_COLLECTED_LINE:
        case FAILED_GET_BOOKING_LINES_CNT:
        case FAILED_GET_BOOKINGLINES:
        case FAILED_CREATE_BOOKING_LINE:
        case FAILED_UPDATE_BOOKING_LINE:
        case FAILED_DELETE_BOOKING_LINE:
        case FAILED_DELETE_BOOKING_LINES:
        case FAILED_GET_LINES_BULK:
        case FAILED_EDIT_LINES_BULK:
            return {
                ...state,
                errorMessage: errorMessage
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// src/state/reducers/bookingLineReducer.js